<ng-container *transloco="let tr; prefix: 'dictionaries'; scope: 'dictionaries'">
  <form nz-form [nzLayout]="'vertical'" [formGroup]="form" (ngSubmit)="submitForm()">
    <div nz-row [nzGutter]="8">
      <div nz-col [nzSpan]="24">
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('entries.form.code')}}</nz-form-label>
          <nz-form-control>
            <input formControlName="code" nz-input>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div nz-row [nzGutter]="8">
      <div nz-col [nzSpan]="24">
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('entries.form.title')}}</nz-form-label>
          <nz-form-control>
            <hx-label-edit formControlName="title"></hx-label-edit>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div nz-row [nzGutter]="8">
      <div nz-col [nzSpan]="24">
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('entries.form.enabled')}}</nz-form-label>
          <nz-form-control>
            <nz-radio-group formControlName="enabled">
              <label nz-radio [nzValue]="true">{{'yes' | transloco}}</label>
              <label nz-radio [nzValue]="false">{{'no' | transloco}}</label>
            </nz-radio-group>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div nz-row [nzGutter]="8">
      <div nz-col [nzSpan]="24">
        <nz-form-item>
          <nz-form-label>{{tr('entries.form.seq')}}</nz-form-label>
          <nz-form-control>
            <nz-input-number formControlName="seq"></nz-input-number>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div nz-row [nzGutter]="8">
      <div nz-col [nzSpan]="24">
        <nz-form-item>
          <nz-form-label>{{tr('entries.form.attributes')}}</nz-form-label>
          <nz-form-control>
            <textarea formControlName="attributes" nz-input></textarea>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <nz-alert *ngIf="form.invalid" nzType="error" [nzMessage]="'error.fillRequiredFields' | transloco"
              nzShowIcon></nz-alert>
  </form>
</ng-container>

<div *nzModalFooter>
  <button (click)="modalRef.close()" nz-button nzType="default">{{ 'button.cancel' | transloco }}</button>
  <button [disabled]="form.pristine || isLoading.save || form.invalid" [nzLoading]="isLoading.save" (click)="submitForm()" nz-button nzType="primary">{{ 'button.save' | transloco }}</button>
</div>

